import { render } from "./PregAllConsult.vue?vue&type=template&id=b2bf2478&scoped=true"
import script from "./PregAllConsult.vue?vue&type=script&lang=js"
export * from "./PregAllConsult.vue?vue&type=script&lang=js"

import "./PregAllConsult.vue?vue&type=style&index=0&id=b2bf2478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2bf2478"]])

export default __exports__